import React from 'react';
import { Button, Flex, Link } from '@gjensidige/builders-components';

import styles from '../../style.scss';
// import { Row, Col } from "@gjensidige/core-grid";
import {
  CalculationFormProps,
  InputHelperTextProps,
  InputItem,
  inputRadioGroupOptions
} from '../../Types';
import { InputRadioGroup } from './InputRadioGroup';
import { InputTextBox } from './InputTextBox';
import { MoreInfoModal } from './MoreInfoModal';

const InputHelperText: React.FC<InputHelperTextProps> = (
  props: InputHelperTextProps
) => {
  const { inputHelperLinkOnClick, inputHelperLinkUrl } = props;
  const clickLinkFunction = (event: any) => {
    event.preventDefault();
    if (inputHelperLinkOnClick) {
      inputHelperLinkOnClick();
    }
  };

  return (
    <Link
      id={props.inputHelpTextId}
      target="_blank"
      rel="noopener noreferrer"
      href={inputHelperLinkUrl ? inputHelperLinkUrl : '#'}
      className={styles.inputHelperLink}
      icon={false}
      onClick={
        inputHelperLinkOnClick
          ? clickLinkFunction
          : () => {
              return false;
            }
      }
    >
      {props.inputHelperLinkText}
    </Link>
  );
};

export const CalculationInputs: React.FC<CalculationFormProps> = (
  props: CalculationFormProps
) => {
  const { calculationInputs, calculateBtn } = props;
  return (
    <form onSubmit={calculateBtn.onClick}>
      <div>
        {calculationInputs.map((inputItem, index) => {
          if (inputItem?.isHidden) {
            return null;
          }
          if (inputItem.type === 'inputText') {
            if (inputItem?.inputListInRow?.length === 1) {
              const inputProps: InputItem = inputItem.inputListInRow[0];
              return (
                <div className={styles.inputListWrapper} key={index}>
                  <InputTextBox inputProps={inputProps} />
                  {inputProps?.inputHelperLinkText && (
                    <InputHelperText
                      inputHelperLinkText={inputProps.inputHelperLinkText}
                      inputHelpTextId={inputProps.inputHelpTextId}
                      inputHelperLinkUrl={inputProps.inputHelperLinkUrl}
                      inputHelperLinkOnClick={
                        inputProps?.inputHelperLinkOnClick
                      }
                    />
                  )}
                  {inputProps?.moreInfoModal && (
                    <MoreInfoModal
                      linkText={inputProps.moreInfoModal.linkText}
                      title={inputProps.moreInfoModal.title}
                      content={inputProps.moreInfoModal.content}
                      closeLabel={inputProps.moreInfoModal.closeLabel}
                      ariaLabel={inputProps.moreInfoModal.ariaLabel}
                      wrapperClassName={
                        inputProps.moreInfoModal.wrapperClassName
                      }
                      ariaDescribedBy={
                        inputProps.moreInfoModal.ariaDescribedBy || ''
                      }
                    />
                  )}
                </div>
              );
            }
            if (inputItem?.inputListInRow?.length > 1) {
              <Flex layout={{ sm: 1, md: 2 }}>
                {inputItem.inputListInRow.map(
                  (inputProps: InputItem, index) => {
                    const isLastItem =
                      index === inputItem.inputListInRow.length;
                    return (
                      <div className={styles.inputListWrapper} key={index}>
                        <InputTextBox inputProps={inputProps} />
                        {isLastItem && inputProps?.inputHelperLinkText && (
                          <InputHelperText
                            inputHelperLinkText={inputProps.inputHelperLinkText}
                            inputHelperLinkUrl={inputProps.inputHelperLinkUrl}
                            inputHelperLinkOnClick={
                              inputProps.inputHelperLinkOnClick
                            }
                            linkAriaDescribedBy={inputProps.id || ''}
                          />
                        )}
                      </div>
                    );
                  }
                )}
              </Flex>;
            }
          }

          if (inputItem.type === 'inputRadio') {
            const radioOptions: inputRadioGroupOptions[] = [];
            const onChangeFn = inputItem.inputListInRow[0].onChange;
            const errorText = inputItem.inputListInRow[0].errorText;
            inputItem.inputListInRow.map((inputProps: InputItem) => {
              radioOptions.push({
                label: inputProps.labelText || '',
                value: inputProps.value || ''
              });
            });
            const invalid = inputItem.inputListInRow.some(
              (item) => item.invalid
            );
            return (
              <Flex
                className={`${styles.inputListWrapper} ${styles.radioGroupWidth}`}
                key={index}
              >
                <InputRadioGroup
                  radioOptions={radioOptions}
                  headerLabel={inputItem.headerLabel}
                  preSelectedValue={inputItem.preSelectedValue}
                  onChange={onChangeFn}
                  errorText={errorText}
                  invalid={invalid}
                  wrapperClass={inputItem.wrapperClassName}
                />
              </Flex>
            );
          }
        })}
        <div className={styles.footerInfo}>
          <Link
            target="_blank"
            rel="noopener noreferrer"
            href={'/om-oss/gdpr'}
            icon={false}
          >
            Läs om hur vi behandlar personuppgifter
          </Link>
        </div>
        <Flex>
          <Button
            {...calculateBtn}
            tracking={calculateBtn.enableTracking}
            loading={calculateBtn.loading}
            disabled={calculateBtn.disabled}
            className={`${calculateBtn.className} ${styles.calculateFooterBtn}`}
            type="submit"
            variant="critical"
          >
            {calculateBtn.btnText}
          </Button>
        </Flex>
      </div>
    </form>
  );
};
